import { prefixStorageKey } from '@futrli/shared-services';

import { PERIOD_TYPE_OPTIONS } from '../../../core/constants';

export const DATE_PERIOD = prefixStorageKey('detailSettings.datePeriod');

export const defaultDetailData = {
  [DATE_PERIOD]: PERIOD_TYPE_OPTIONS.MONTHLY
};
